import { useTranslation } from "react-i18next";
import WasteMetadataFields from "../photoCapture/WasteMetadataFields";

const NotificationCharacterizationForm = ({
  selectedClient,
  onClientChange,
  selectedWasteCategory,
  onWasteCategoryChange,
  identificationReference,
  onIdentificationReferenceChange,
  weightTonnes,
  onWeightChange,
  commentText,
  onCommentChange,
  clientOptions,
  wasteCategoryOptions,
  disabled = false,
  onActiveFieldSheetChange,
  onFieldCommit,
}) => {
  const { t } = useTranslation();

  return (
    <div className="notification-detail-form-card">
      <h2 className="photo-capture-metadata-page-title">
        {t("mobile_photo_metadata_sheet_title")}
      </h2>

      <WasteMetadataFields
        selectedClient={selectedClient}
        onClientChange={onClientChange}
        selectedWasteCategory={selectedWasteCategory}
        onWasteCategoryChange={onWasteCategoryChange}
        identificationReference={identificationReference}
        onIdentificationReferenceChange={onIdentificationReferenceChange}
        weightTonnes={weightTonnes}
        onWeightChange={onWeightChange}
        commentText={commentText}
        onCommentChange={onCommentChange}
        clientOptions={clientOptions}
        wasteCategoryOptions={wasteCategoryOptions}
        disabled={disabled}
        onActiveFieldSheetChange={onActiveFieldSheetChange}
        onFieldCommit={onFieldCommit}
      />
    </div>
  );
};

export default NotificationCharacterizationForm;
